export default "__VITE_ASSET__DCCc59Iz__"